import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },

  {
    path: '/generator',
    name: 'generator',
    component: () =>
      import(/* webpackChunkName: "generator" */ '../views/Generator')
  },

  {
    path: '/rules',
    name: 'rules',
    component: () => import(/* webpackChunkName: "rules" */ '../views/Rules')
  },

  {
    path: '/battlefield',
    name: 'battlefield',
    component: () =>
      import(/* webpackChunkName: "battlefield" */ '../views/Battlefield')
  },

  {
    path: '/effects',
    name: 'effects',
    component: () =>
      import(/* webpackChunkName: "effects" */ '../views/Effects')
  },

  {
    path: '/modes',
    name: 'modes',
    component: () => import(/* webpackChunkName: "modes" */ '../views/Modes')
  },

  {
    path: '/races',
    name: 'races',
    component: () => import(/* webpackChunkName: "races" */ '../views/Races')
  },

  {
    path: '/classes',
    name: 'classes',
    component: () =>
      import(/* webpackChunkName: "classes" */ '../views/Classes')
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  }
})

export default router
